import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { KeyRound } from "lucide-react";

export default function Account() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setMsg(""); setErr("");
    if (form.new_password !== form.confirm) { setErr("Konfirmasi password tidak sama"); return; }
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      setForm({ current_password: "", new_password: "", confirm: "" });
      setMsg("Password berhasil diganti. Sesi di perangkat lain otomatis keluar.");
    } catch (ex) { setErr(errMsg(ex)); }
  }

  const input = "w-full mt-1 border border-[#E2DDD3] rounded-lg px-3 h-11";
  return (
    <div className="p-4 sm:p-8 space-y-6 max-w-xl">
      <header>
        <h1 className="text-2xl sm:text-3xl font-serif-display font-bold">Akun Saya</h1>
        <p className="text-sm text-[#536263]">{user?.name} · {user?.email} · {user?.role}</p>
        <div className="mt-2 h-px w-12 bg-[#B87333]"></div>
      </header>
      <form onSubmit={submit} className="card-editorial p-5 space-y-4" data-testid="change-password-form">
        <h2 className="font-serif-display text-xl font-semibold flex items-center gap-2"><KeyRound size={18} />Ganti Password</h2>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#B87333]">Password saat ini</label>
          <input type="password" required value={form.current_password} onChange={e => setForm({ ...form, current_password: e.target.value })} className={input} data-testid="current-password-input" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#B87333]">Password baru</label>
          <input type="password" required minLength={8} value={form.new_password} onChange={e => setForm({ ...form, new_password: e.target.value })} className={input} data-testid="new-password-input" />
          <p className="text-[11px] text-[#8A999A] mt-1">Minimal 8 karakter, berisi huruf dan angka.</p>
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#B87333]">Ulangi password baru</label>
          <input type="password" required value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })} className={input} data-testid="confirm-password-input" />
        </div>
        {err && <div className="text-sm text-red-700" data-testid="change-password-error">{err}</div>}
        {msg && <div className="text-sm text-emerald-700" data-testid="change-password-success">{msg}</div>}
        <button className="btn-primary w-full" data-testid="change-password-submit">Simpan Password</button>
      </form>
    </div>
  );
}
